import "./Peo-Culture.css";
import Footer from "./Footer";

export default function PeopleCulture() {
    return (
        <section id="peo-cul">
            <div className="culture-page">

                {/* TOP SECTION */}
                <div className="culture-top">
                    <div className="culture-text">
                        <h3>Culture</h3>
                        <h4>Rooted in values. Driven by Excellence.</h4>
                        <p>
                            At Sundaram Clayton Limited (SCL), people are at the heart of everything we do. Our culture is rooted in strong values, and our careers are built on growth, learning and care — creating an environment where individuals and teams thrive together.
                        </p>
                    </div>

                    <div className="culture-image">
                        <img src={require("../assets/peo-img3.png")} alt="Culture at SCL" />
                    </div>
                </div>

                {/* WHAT DEFINES OUR CULTURE */}
                <div className="culture-defines">
                    <h3>What defines our culture</h3>
                    <div className="culture-underline"></div>

                    <ul>
                        <li>Customer-centric and growth-oriented mindset</li>
                        <li>World-class quality driven by TPM, TQM, Lean and Six Sigma</li>
                        <li>Strong focus on safety, sustainability and social responsibility</li>
                        <li>Transparency, fairness and integrity at every level</li>
                    </ul>
                </div>

                {/* LIFE AT SCL */}
                <div className="life-at-scl">
                    <h3>Life at SCL</h3>
                    <div className="culture-underline1"></div>
                    <div className="life-cards">
                        <div className="life-card">
                            <h4>At Work</h4>
                            <ul>
                                <li>Diverse and inclusive workplace</li>
                                <li>Recognition programs such as Star of the Month</li>
                                <li>Change management and continuous improvement initiatives</li>
                            </ul>
                        </div>

                        <div className="life-card">
                            <h4>Engagement</h4>
                            <ul>
                                <li>Learning milestones and graduation ceremonies</li>
                                <li>Cultural and festival celebrations</li>
                                <li>Employee outings, sports and team activities</li>
                                <li>National and social initiatives, including blood donation camps</li>
                            </ul>
                        </div>

                        <div className="life-card">
                            <h4>Beyond Work</h4>
                            <ul>
                                <li>TSS scholarships for employees’ children</li>
                                <li>Creche facilities and Children’s Day celebrations</li>
                            </ul>
                        </div>
                    </div>

                    <p className="life-note">
                        Our culture ensures that every employee feels respected, valued and connected.
                    </p>
                </div>

                {/* DEVELOPING PEOPLE & LEADERS */}
                <div className="developing-section">
                    <h3>Developing People & Leaders</h3>
                    <div className="culture-underline2"></div>
                    <div className="developing-images">
                        <img src={require("../assets/peo-collage2.png")} alt="Leadership Development" />
                        <img src={require("../assets/peo-collage1.png")} alt="People Development" />
                    </div>
                    <div className="developing-box">
                        <h4>Leadership Development</h4>
                        <p>
                            We invest in building future-ready leaders through structured, purpose-driven programs aligned to business and organisational goals.
                        </p>
                        <ul>
                            <li>
                                Emerging Leaders Program (ELP)
                            </li>
                            <li>
                                Advanced Leaders Program (ALP)
                            </li>
                            <li>Executive Leaders Program (XLP)</li>
                        </ul>
                        <p>
                            Each program is designed to strengthen leadership capability, agility and strategic thinking
                        </p>
                    </div>

                    <div className="developing-box">
                        <h4>Competency Development Journey</h4>
                        <p>
                            Our competency development framework enables continuous learning across roles and levels — strengthening technical expertise, behavioural capabilities and functional excellence to support individual and organisational growth.
                        </p>
                    </div>
                </div>

            </div>

            <Footer />
        </section>
    );
}
